<template>
    <basic-map-popover
        class="restaurant-map-popover"
        :title="name"
        :address="address"
    >
        <p
            v-if="tel"
            class="tel"
        >
            <strong>{{ $snippet('tel', 'tel') }}</strong>
            <a
                :href="`tel:${ tel }`"
                v-test:tel
            >
                {{ tel }}
            </a>
        </p>

        <template v-if="providers.length">
            <p><strong>{{ $snippet('click_to_order', 'click to order') }}</strong></p>

            <ul>
                <li
                    v-for="provider in providers"
                    :key="provider.name"
                >
                    <a
                        :href="provider.url"
                        target="_blank"
                        rel="noopener"
                        v-test:providerLink
                    >
                        <span
                            class="sr-only"
                            v-test:providerA11yText
                        >
                            {{ $snippet('order_on', 'order on') }} {{ provider.name }}
                        </span>
                        <component
                            :is="provider.image"
                        />
                    </a>
                </li>
            </ul>
        </template>

        <b-button
            variant="primary"
            :to="to"
            block
            v-test:pageLink
        >
            {{ $snippet('store_information', 'store information') }}
        </b-button>
    </basic-map-popover>
</template>

<script>
    import DeliverooLogo from '../../../assets/images/svgs/deliveroo-logo.svg?inline';
    import UberEatsLogo from '../../../assets/images/svgs/uber-eats-logo.svg?inline';
    import JustEatLogo from '../../../assets/images/svgs/just-eat-logo.svg?inline';
    import BasicMapPopover from '../BasicMapPopover/BasicMapPopover.vue';

    export default {
        name: 'restaurant-map-popover',

        components: {
            BasicMapPopover,
            DeliverooLogo,
            UberEatsLogo,
            JustEatLogo,
        },

        props: {
            name: {
                type: String,
                required: true,
            },

            address: {
                type: String,
                required: true,
            },

            tel: {
                type: String,
                default: '',
            },

            deliverooUrl: {
                type: String,
                default: '',
            },

            uberEatsUrl: {
                type: String,
                default: '',
            },

            justEatUrl: {
                type: String,
                default: '',
            },

            to: {
                type: String,
                required: true,
            },
        },

        computed: {
            /**
             * Return the available providers.
             *
             * @returns {({image, name: string, url: string}|{image, name: string, url: string}|{image, name: string, url: string})[]}
             */
            providers() {
                return [
                    {
                        name: 'Deliveroo',
                        url: this.deliverooUrl,
                        image: DeliverooLogo,
                    },
                    {
                        name: 'UberEats',
                        url: this.uberEatsUrl,
                        image: UberEatsLogo,
                    },
                    {
                        name: 'JustEat',
                        url: this.justEatUrl,
                        image: JustEatLogo,
                    },
                ].filter(({ url }) => url);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .tel {
        margin-bottom: 10px;

        strong {
            color: $primary;
        }

        a {
            color: inherit;
        }
    }

    ul {
        list-style: none;
        padding: 0;
        display: flex;
        margin: 0 -5px;
        align-items: center;
    }

    li {
        padding: 0 5px;
        width: 33.3333%;

        &:nth-child(2) {
            text-align: center;
        }

        &:nth-child(3) {
            text-align: right;
        }
    }

    svg {
        max-height: 47px;
        width: auto;
        max-width: 100%;
    }

    .btn {
        margin-top: 20px;
        min-width: unset;
        font-size: rem(12px);
        @include media-breakpoint-up(sm) {
            font-size: $btn-font-size;
        }
    }
</style>
